import { render, staticRenderFns } from "./FinishRegistrationPage.vue?vue&type=template&id=7b84a6b8"
import script from "./FinishRegistrationPage.vue?vue&type=script&lang=js"
export * from "./FinishRegistrationPage.vue?vue&type=script&lang=js"
import style0 from "./FinishRegistrationPage.vue?vue&type=style&index=0&id=7b84a6b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports